import {gql} from "@apollo/client";

export const DSP_ARRIVAL_SCAN = gql`
  mutation DeliveryMutation($input: ScanInput!) {
    handleDspArrivalScanEvent(input: $input) {
      id
      trackingNumber
      routeName
      stopNumber
      subStopNumber
      isPickedUp
    }
  }
`;

export interface DspArrivalScanType {
    id: string;
    trackingNumber: string;
    routeName: string;
    stopNumber: number;
    subStopNumber: string;
    isPickedUp:boolean;
}

export interface DspArrivalScanResponse {
    handleDspArrivalScanEvent: DspArrivalScanType[];
}

interface DspArrivalScanInput {
    trackingNumber: string;
    scanLocation: {
        latitude: number;
        longitude: number;
    };
}

export interface DspArrivalScanVariables {
    input: DspArrivalScanInput;
}